import React from 'react';

import PropTypes from 'prop-types';

import Sidebar from './components/Sidebar';
import SidebarInset from './components/SidebarInset';

const WorkspaceLayout = ({ children }) => (
  <>
    <Sidebar />
    <SidebarInset>{children}</SidebarInset>
  </>
);

WorkspaceLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WorkspaceLayout;
